type TaskSeverityLevel = {
    id: string;
    displayName: string;
    severity: number;
};

// The `severity` numbers mirror admin-service's TaskSeverityLevel ints (lower = higher priority);
// only the relative order carries meaning.
export const TaskSeverityLevels: Record<string, TaskSeverityLevel> = {
    CodeBlue: {
        id: 'CODE_BLUE',
        displayName: 'Code Blue',
        severity: 0,
    },
    Wander: {
        id: 'WANDER',
        displayName: 'Wander',
        severity: 0,
    },
    PotentialFall: {
        id: 'POTENTIAL_FALL',
        displayName: 'Potential Fall Detected',
        severity: 1,
    },
    ProactiveFallRisk: {
        id: 'PROACTIVE_FALL_RISK',
        displayName: 'Fall Risk Detected',
        severity: 2,
    },
    Emergency: {
        id: 'EMERGENCY',
        displayName: 'Emergency',
        severity: 3,
    },
    StaffAssist: {
        id: 'STAFF_ASSIST',
        displayName: 'Staff Assist',
        severity: 4,
    },
    ProppedDoor: {
        id: 'PROPPED_DOOR',
        displayName: 'Propped Door',
        severity: 5,
    },
    UnauthorizedExit: {
        id: 'UNAUTHORIZED_EXIT',
        displayName: 'Unauthorized Exit',
        severity: 5,
    },
    DoorOpen: {
        id: 'DOOR_OPEN',
        displayName: 'Door Open',
        severity: 6,
    },
    EscalationObservation: {
        id: 'ESCALATION_OBSERVATION',
        displayName: 'Escalation observation',
        severity: 10,
    },
    High: {
        id: 'HIGH_PRIORITY',
        displayName: 'High priority',
        severity: 90,
    },
    Medium: {
        id: 'MEDIUM_PRIORITY',
        displayName: 'Medium priority',
        severity: 91,
    },
    Low: {
        id: 'LOW_PRIORITY',
        displayName: 'Low priority',
        severity: 92,
    },

    NoPriority: {
        id: 'NO_PRIORITY',
        displayName: 'None',
        severity: 100,
    },
};

export const TaskSeverityLevelsValues = Object.values(TaskSeverityLevels).map(({ id }) => id);

export const ResidentAlertSeverities = [
    TaskSeverityLevels.CodeBlue.id,
    TaskSeverityLevels.PotentialFall.id,
    TaskSeverityLevels.ProactiveFallRisk.id,
    TaskSeverityLevels.Emergency.id,
    TaskSeverityLevels.StaffAssist.id,
];

export const DoorAlertSeverities = [
    TaskSeverityLevels.ProppedDoor.id,
    TaskSeverityLevels.UnauthorizedExit.id,
    TaskSeverityLevels.DoorOpen.id,
];

export const AllAlertSeverities = [...ResidentAlertSeverities, ...DoorAlertSeverities];

export const DetectAlertSeverities = [
    TaskSeverityLevels.PotentialFall.id,
    TaskSeverityLevels.ProactiveFallRisk.id,
];

export type DoorAlertSeverityId = 'PROPPED_DOOR' | 'UNAUTHORIZED_EXIT' | 'DOOR_OPEN';

export const isAlertSeverity = (severityId?: string) => {
    return AllAlertSeverities.some((alertSeverityId) => alertSeverityId === severityId);
};

export const isDetectAlertSeverity = (severityId?: string) => {
    return DetectAlertSeverities.some(
        (detectAlertSeverityId) => detectAlertSeverityId === severityId
    );
};

export const isDoorAlertSeverity = (severityId?: string) => {
    return DoorAlertSeverities.some((doorAlertSeverityId) => doorAlertSeverityId === severityId);
};
